// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","Photos__row":"sr_a bhg_a bhg_r bhg_j","Photos__img":"sr_b bhg_b"};